module.exports = __webpack_public_path__ + "img/export.fea3e540.svg";